import React, {useState} from "react";
import {Button, Dialog, DialogBody, DialogFooter, FormGroup, NumericInput} from "@blueprintjs/core";
import PropTypes from "prop-types";
import MapboxPlot from "../MapboxPlot";
import {layouts, MapMode} from "../../MapboxLayouts";
import MapboxDragnDrop from "../MapboxDragnDrop";
import { Alert } from "react-bootstrap";

export default function LocationDialog({device, deviceMutation, isDialogOpen, closeDialog}) {

    const currentLocation = device.currentLocation;

    const [latitude, setLatitude] = useState(() => `${currentLocation?.latitude || 0}`);
    const [longitude, setLongitude] = useState(() => `${currentLocation?.longitude || 0}`);
    const [showAlert, setShowAlert ] = useState(false);

    function isValidLatitude(lat) {
        if (lat <= 90 && lat >= -90){
            return true
        }
        return false
    }

    function isValidLongitude(long) {
        if (long <= 180 && long >= -180){
            return true
        }
        return false
    }

    function save(){
        if (isValidLatitude(parseFloat(latitude)) && isValidLongitude(parseFloat(longitude))){
            deviceMutation.mutate({
                deviceId: device.id,
                action: "update",
                latitude: parseFloat(latitude),
                longitude: parseFloat(longitude)
            });
            closeDialog();
        } else {
            // Invalid coordinates
            setShowAlert(true)
        }
    }

    function deleteLocation(){
        deviceMutation.mutate({
            deviceId: device.id,
            action: "update",
            deleteLocation: true
        });
        closeDialog();
    }

    return <Dialog title="Location" icon="info-sign" isOpen={isDialogOpen} onClose={() => {
                closeDialog()
                setShowAlert(false)
            }} style={{display:'flex',flexDirection:'column', height:'100%'}}
            >
        <div className="dialog-body">
            {showAlert ? <Alert variant="danger" style={{position:'sticky', top:'10px', zIndex:'999'}}>
                Invalid latitude or longitude. Please check your input values.
            </Alert> : null}
            <div>
                {
                    !currentLocation ? 
                        <div><b>Coordinates:</b> <b>Not Set</b></div> :
                            (currentLocation?.manual && currentLocation?.current)
                            ? <div><b>Coordinates:</b> Set <b>Manually</b></div>
                            : <div><b>Coordinates:</b> Set by <b>Device GPS</b></div>
                }

                <FormGroup
                    helperText="Latitude of the device"
                    label="Latitude"
                    labelFor="lat-input"
                    labelInfo="(required)"
                >
                    <NumericInput
                        id="lat-input"
                        placeholder=""
                        value={latitude}
                        onValueChange={(value, s) => setLatitude(s)}
                    />
                </FormGroup>
                <FormGroup
                    helperText="Longitude for the device"
                    label="Longitude"
                    labelFor="lon-input"
                    labelInfo="(required)"
                >
                    <NumericInput
                        id="lon-input"
                        placeholder=""
                        value={longitude}
                        onValueChange={(value, s) => setLongitude(s)}
                    />
                </FormGroup>
            </div>
            <div style={{width:'100%'}}>
                <MapboxDragnDrop
                    sensor={device}
                    mapboxLayout={layouts[0]}
                    latitude={latitude}
                    longitude={longitude}
                    setLatitude={setLatitude}
                    setLongitude={setLongitude}
                />
            </div>
        </div>
        <DialogFooter actions={<>
            <Button intent="none" text="Cancel" onClick={() => {
                closeDialog()
                setShowAlert(false)
            }} />
            <Button intent="danger" text="Use Device GPS" onClick={() => deleteLocation()} />
            <Button intent="primary" text="Save" onClick={() => save()} />
            </>}
        />
    </Dialog>
}

LocationDialog.propTypes = {
    device: PropTypes.object,
    deviceMutation: PropTypes.object,
    isDialogOpen: PropTypes.bool,
    closeDialog: PropTypes.func
}